module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-cultura-info gv-inverted-color-scheme",
    attrs: {
      "id": "gv-cultura-info"
    }
  }, [_vm._c('div', {
    directives: [{
      name: "draggable",
      rawName: "v-draggable"
    }],
    staticClass: "gv-cultura-info-title gv-color-scheme",
    attrs: {
      "id": "gv-cultura-info-title"
    }
  }, [_vm._c('strong', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._c('el-button', {
    staticClass: "gv-close gv-color-scheme",
    attrs: {
      "icon": "el-icon-close",
      "type": "button",
      "title": "Chiudi Panello",
      "alt": "Chiudi Panello"
    },
    on: {
      "click": _vm.closePanel
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }]
  }, [_vm._c('div', {
    staticClass: "gv-cultura-info-body",
    attrs: {
      "id": "gv-cultura-info-body"
    }
  }, [_vm._c('div', {
    staticClass: "gv-cultura-info-scheda"
  }, [_vm._c('div', {
    staticStyle: {
      "font-size": "20px",
      "width": "90%"
    }
  }, [_vm._c('strong', [_vm._v(_vm._s(_vm.properties.NOME.toUpperCase()))])]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('div', {
    staticStyle: {
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.properties.INDIRIZZO_FORMAT))]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('div', {
    staticStyle: {
      "width": "90%"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.properties.RAGGRUPPAMENTO) + " / "), _vm._c('strong', [_vm._v(_vm._s(_vm.properties.CATNAME))])]), _vm._v(" "), (_vm.properties.DESCRIZIONE_BREVE) ? _vm._c('div', {
    staticClass: "gv-cultura-info-descrizione"
  }, [_vm._c('pre', [_vm._c('em', [_vm._v(_vm._s(_vm.properties.DESCRIZIONE_BREVE))])])]) : _vm._e(), _vm._v(" "), (_vm.properties.DESCRIZIONE) ? _vm._c('div', {
    staticClass: "gv-cultura-info-descrizione"
  }, [_vm._c('pre', [_vm._v(_vm._s(_vm.properties.DESCRIZIONE))])]) : _vm._e(), _vm._v(" "), (_vm.properties.opere.length > 0) ? _vm._c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.properties.opere), function(item) {
    return _vm._c('ul', {
      key: item.id
    }, [_vm._c('li', [_vm._v(_vm._s(item.nome))])])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.properties.GALLERY.length > 0) ? _vm._c('div', {
    staticClass: "gv-cultura-info-button"
  }, [_vm._c('el-button', {
    attrs: {
      "alt": "Galleria Immagini",
      "size": "mini",
      "type": "info"
    },
    on: {
      "click": _vm.showGallery
    }
  }, [_vm._v("Galleria Immagini")])], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('strong', [_vm._v("Alcune opere correlate")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-91afbe08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CulturaInfo.vue
// module id = 890
// module chunks = 39